import { iconStyle } from "./styles";

export const BLUE_DOT_TEST_ID = "blue-dot-icon";

export default function BlueDotIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={iconStyle}
      data-testid={BLUE_DOT_TEST_ID}
    >
      <path
        opacity="0.5"
        d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z"
        fill="#B3CEFD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill="#3F6DE9"
      />
    </svg>
  );
}
